import apiRequestCommon from './index'

export default {
  path: '/v1/other_coupon',
  // get (bCleID, popinfoId, tsid, token) {
  //   return apiRequestCommon.get(`${this.path}/${bCleID}/${popinfoId}/${tsid}/${token}`)
  // }
  async get (bCleID, popinfoId, tsid, token, appVersionHeader) {
    await window.callNativeHTTPX()
    let headersParam = {
      'HTTP-X-DAPP-REQUESTTIME': window.DAPP_REQUESTTIME,
      'HTTP-X-DAPP-USERID': window.DAPP_USERID,
      'HTTP-X-DAPP-AUTHCD': window.DAPP_AUTHCD,
      'X-CLS-App-Version': appVersionHeader
    }
    console.log('*** call API otherCouponAPI ***')
    console.log(headersParam)
    // ローカルは認証情報を参照しないように変更する
    if (process.env.VUE_APP_LOCAL === 'true') {
      headersParam = {
        'HTTP-X-DAPP-USERID': '93aba821-2e63-482b-af97-**********',
        'HTTP-X-DAPP-REQUESTTIME': '1562043459',
        'HTTP-X-DAPP-AUTHCD': '9f4fa2f510ca52e19e2e63**************************',
        'X-CLS-App-Version': appVersionHeader
      }
    }
    return apiRequestCommon.get(`${this.path}/${bCleID}/${popinfoId}/${tsid}/${token}`, {
      headers: headersParam
    })
  }
}
